import { axios } from "../middleware";

import { LinkPlaidAccount, ShipperSettingsData, UserSettingsData } from "models/UserSetting";

//get stripe subscription
export const getStripeSubscriptionAPI = async () => {
  return axios.get(`/stripe/subscription/`);
};

//get subscription history
export const getSubscriptionHistoryAPI = async () => {
  return axios.get(`/payment/history/?subscription=true`);
};

//send subscription feedback
export const sendSubscriptionFeedbackAPI = async (data: { message: string }) => {
  return axios.post(`/help/feedback/`, data);
};

//submit a support ticket (emails the support team + confirmation to the user)
export const postSupportTicketAPI = async (data: {
  name: string;
  email: string;
  message: string;
}) => {
  return axios.post(`/help/`, data);
};

//post subscription
export const postSubscriptionAPI = async (stripe_token: string, plan: string) => {
  return axios.post(`/stripe/subscription/`, { stripe_token, plan });
};

//delete subscription history
export const deleteSubscriptionHistoryAPI = async () => {
  return axios.delete(`stripe/subscription/`);
};

//link plaid account
export const linkPlaidAccountAPI = async (data: LinkPlaidAccount) => {
  return axios.post(`/plaid/exchange_token/`, data);
};

//get Plaid Link
export function getLinkToken<T>(): Promise<T> {
  return axios.get<T>("/plaid/create_link_token/").then((response) => response.data);
}

//change user password
export const updatePasswordAPI = async (userId: string, password: string) => {
  return axios.patch(`/users/${userId}/`, { password });
};

//get previous rating
export const getPreviousRatingAPI = async (userId: string) => {
  return axios.get(`/user/${userId}/ratings/`, {
    params: {
      limit: 20,
      ordering: "-time_posted"
    }
  });
};

//post rating
export const postRatingAPI = async (userId: string, rating: number, comment: string) => {
  return axios.post(`/user/${userId}/ratings/`, { rating, comment });
};

//update rating
export const updateRatingAPI = async (userId: string, rating: number, comment: string) => {
  return axios.patch(`/user/${userId}/ratings/`, { rating, comment });
};

//get user settings
export const getUserSettingsAPI = async () => {
  return axios.get(`/usersettings/`);
};

//get shipper settings
export const getShipperSettingsAPI = async () => {
  return axios.get(`/shippersettings/`);
};

//send verification email
export const sendVerificationEmailAPI = async () => {
  return axios.post(`/user/verify_email_token/?generate_new_token=true`);
};

//verify the token from the Account Verification email link
export const verifyEmailTokenAPI = async (token: string) => {
  return axios.post(`/user/verify_email_token/`, { token });
};

//update shipper settings
export const updateShipperSettingsAPI = async (params: ShipperSettingsData) => {
  return axios.put(`/shippersettings/`, params);
};

//update user settings
export const updateUserSettingsAPI = async (params: UserSettingsData) => {
  return axios.put(`/usersettings/`, params);
};

//get block users
export const getBlockUsersAPI = async () => {
  return axios.get(`/user/relationships/`);
};

//post block users
export const postBlockUsersAPI = async (userId: string) => {
  return axios.post(`/user/relationships/`, { status: "Blocked", to_user: userId });
};

//remove block users
export const unblockUserAPI = async (userId: string) => {
  return axios.delete(`/user/relationships/${userId}/`);
};

//generate API token
export const generateAPIToken = async () => {
  return axios.post(`/auth/access_tokens/`);
};

//fetch API token
export const fetchAPITokenAPI = async () => {
  return axios.get(`/auth/access_tokens/`);
};
